import { useMemo } from 'react';
import PropTypes from 'prop-types';
import SchemaField, { SchemaFormContext } from './SchemaField';
import './SchemaForm.scss';

/**
 * Form generated from a JSON Schema (plain types, enums, arrays, maps); unsupported parts are edited as JSON.
 * Errors are keyed by path in the backend notation, e.g. "levels[0].levelName"; "" is the root.
 */
const SchemaForm = ({
  schema,
  value,
  errors = {},
  onChange,
  isDisabled,
  isReadOnly = false,
  idPrefix = 'schema-form'
}) => {
  const formContext = useMemo(() => ({ idPrefix, isReadOnly }), [idPrefix, isReadOnly]);

  return (
    <SchemaFormContext.Provider value={formContext}>
      <div className={'schema-form'}>
        <SchemaField
          schema={schema}
          value={value}
          path={''}
          errors={errors}
          onChange={onChange}
          isDisabled={isDisabled || isReadOnly}
        />
      </div>
    </SchemaFormContext.Provider>
  );
};

SchemaForm.propTypes = {
  schema: PropTypes.object.isRequired,
  value: PropTypes.any,
  errors: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool,
  isReadOnly: PropTypes.bool,
  idPrefix: PropTypes.string
};

export default SchemaForm;
